import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import pdfPlaceholder from "../../assets/pdf-placeholder.svg";
import {
  buildAudioThumbnailUrlFromResource,
  resolveAudioThumbnail,
} from "../../assets/audio-presets";
import { Resource } from "../../types";
import { useStyles } from "./styles";

type Props = {
  resource: Resource;
  onEditImage?: () => void;
  onDelete?: () => void;
};

const formatSize = (bytes?: number) => {
  if (!bytes && bytes !== 0) return "";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) return `${Math.round(mb)} MB`;
  const kb = bytes / 1024;
  return `${Math.round(kb)} KB`;
};

export const ResourcePreview = ({ resource, onEditImage, onDelete }: Props) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const videoSrc =
    resource.resourceType === "video"
      ? `${resource.url || resource.resourcePath || ""}#t=0.5`
      : undefined;

  const audioThumbSrc =
    resource.resourceType === "audio"
      ? resolveAudioThumbnail(
          resource.thumbnailPath,
          buildAudioThumbnailUrlFromResource(
            resource.url,
            resource.resourcePath,
            resource.thumbnailPath
          )
        )
      : undefined;

  return (
    <div className={styles.card}>
      <div className={styles.thumb}>
        {resource.resourceType === "pdf" && (
          <img src={pdfPlaceholder} alt="pdf" className={styles.media} />
        )}
        {resource.resourceType === "video" && videoSrc && (
          <video
            className={styles.media}
            src={videoSrc}
            preload="metadata"
            muted
            playsInline
          />
        )}
        {resource.resourceType === "audio" && (
          <img src={audioThumbSrc} alt="audio" className={styles.media} />
        )}

        {resource.resourceType === "audio" && onEditImage && (
          <Tooltip title={t("DAILY_ACTIVITY.CHANGE_AUDIO_IMAGE")}>
            <IconButton
              size="small"
              className={styles.editBtn}
              onClick={onEditImage}
              aria-label="edit audio image"
            >
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title={t("TOOLTIP.DELETE")}>
            <IconButton
              size="small"
              className={styles.deleteBtn}
              onClick={onDelete}
              aria-label="delete resource"
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
